import { render, staticRenderFns } from "./HeaderSpace.vue?vue&type=template&id=f72227b2&scoped=true&"
import script from "./HeaderSpace.vue?vue&type=script&lang=js&"
export * from "./HeaderSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72227b2",
  null
  
)

export default component.exports